// Prepare payment information before the customer reaches the product price.
// Checkout payment methods are provided independently by Shopify checkout.
(function () {
  var pending = document.querySelectorAll('script[data-payment-src]');
  if (!pending.length) return;
  var block = document.querySelector('[data-payment-options]');
  var started = false;
  var observer;
  function load() {
    if (started) return;
    started = true;
    if (observer) observer.disconnect();
    pending.forEach(function (placeholder) {
      var script = document.createElement('script');
      script.src = placeholder.dataset.paymentSrc;
      script.async = true;
      script.onload = function () {
        document.dispatchEvent(new CustomEvent('aor:payment-messaging-ready'));
      };
      document.head.appendChild(script);
    });
  }
  if (!block || !('IntersectionObserver' in window)) {
    load();
    return;
  }
  block.addEventListener('focusin', load, { once: true });
  block.addEventListener('pointerdown', load, { once: true });
  observer = new IntersectionObserver(function (entries) {
    if (entries.some(function (entry) { return entry.isIntersecting; })) load();
  }, { rootMargin: '400px 0px' });
  observer.observe(block);
})();
